import React from "react";
import { theme } from "codeArt/components/Base";
import { DataContext } from "./context";
import { getRandom } from "app/components/common";

//在当前页面的路由表页面进行调用 否则不进行触发调用

const getChartData = () => {
  let xMin = 400;
  let xMax = 1800;
  let xStart = 6.0;
  let xEnd = 11.3;
  let yScope = 0.1;

  let lineData1 = [],
    lineData2 = [];

  let ySet = getRandom(2380, 2395) / 100;
  let plus = true;

  for (let i = xMin; i <= xMax; i = i + 3) {
    let x = i / 100;

    let y = 0.0;
    if (x < xStart || x > xEnd) {
    } else {
      let data1 = [],
        data2 = [];
      data1.push(x);
      data2.push(x);

      let offset = getRandom(0, yScope * 100) / 100;

      if (plus) y = ySet + offset;
      else {
        y = ySet - offset;
      }

      data1.push(Math.floor(y * 100) / 100);
      data2.push(ySet);

      lineData1.push(data1);
      lineData2.push(data2);

      plus = !plus;
    }
  }

  return { data1: lineData1, data2: lineData2 };
};

const cycleRecord = [
  [
    { reason: "12:22:31", old: "11", new: "12", count: "12" },
    { reason: "12:42:11", old: "2", new: "11", count: "11" },
    { reason: "12:51:53", old: "5", new: "2", count: "2" },
    { reason: "12:59:05", old: "4", new: "5", count: "5" },
    { reason: "13:05:33", old: "8", new: "4", count: "4" },
    { reason: "13:12:41", old: "5", new: "8", count: "8" }
  ],
  [
    { reason: "08:11:31", old: "33", new: "23", count: "23" },
    { reason: "09:42:11", old: "44", new: "33", count: "33" },
    { reason: "08:51:53", old: "5", new: "44", count: "44" },
    { reason: "07:59:05", old: "6", new: "5", count: "5" },
    { reason: "13:05:33", old: "7", new: "6", count: "6" },
    { reason: "12:12:41", old: "23", new: "7", count: "7" },
    { reason: "07:41:31", old: "36", new: "23", count: "23" },
    { reason: "09:52:31", old: "12", new: "36", count: "36" },
    { reason: "02:11:43", old: "51", new: "12", count: "12" },
    { reason: "04:43:45", old: "42", new: "51", count: "51" },
    { reason: "02:55:53", old: "9", new: "42", count: "42" },
    { reason: "11:22:41", old: "11", new: "9", count: "9" },
    { reason: "11:41:33", old: "13", new: "11", count: "11" },
    { reason: "12:11:21", old: "6", new: "13", count: "9" },
    { reason: "13:25:53", old: "13", new: "6", count: "6" }
  ],
  [
    { reason: "12:23:31", old: "9", new: "8", count: "8" },
    { reason: "15:42:11", old: "12", new: "9", count: "9" },
    { reason: "10:51:53", old: "23", new: "12", count: "12" },
    { reason: "09:59:05", old: "44", new: "23", count: "23" },
    { reason: "13:05:33", old: "55", new: "44", count: "44" },
    { reason: "12:15:41", old: "22", new: "55", count: "55" }
  ]
];

const cycleReason = [
  [
    { reason: "甘油", count: "12", last: "12:22:31" },
    { reason: "缝隙", count: "11", last: "12:42:11" },
    { reason: "丝绸", count: "2", last: "12:51:53" },
    { reason: "接头", count: "5", last: "12:59:05" },
    { reason: "破损", count: "4", last: "13:05:33" },
    { reason: "相位", count: "8", last: "13:12:41" }
  ],
  [
    { reason: "甘油", count: "22", last: "08:11:31" },
    { reason: "缝隙", count: "9", last: "09:42:11" },
    { reason: "丝绸", count: "33", last: "08:51:53" },
    { reason: "接头", count: "4", last: "07:59:05" },
    { reason: "破损", count: "55", last: "13:05:33" },
    { reason: "相位", count: "6", last: "12:12:41" },
    { reason: "多珠", count: "24", last: "14:13:11" },
    { reason: "少珠", count: "1", last: "14:52:31" },
    { reason: "色差", count: "35", last: "15:12:22" },
    { reason: "跳棒", count: "73", last: "15:34:51" },
    { reason: "珠直径", count: "6", last: "15:45:21" },
    { reason: "段数", count: "3", last: "15:46:33" },
    { reason: "同料", count: "5", last: "15:23:23" },
    { reason: "丝束的进量", count: "21", last: "15:44:53" },
    { reason: "速比(V1/V0)", count: "5", last: "16:53:23" }
  ],
  [
    { reason: "甘油", count: "11", last: "12:23:31" },
    { reason: "缝隙", count: "23", last: "15:42:11" },
    { reason: "丝绸", count: "9", last: "10:51:53" },
    { reason: "接头", count: "4", last: "09:59:05" },
    { reason: "破损", count: "8", last: "13:05:33" },
    { reason: "相位", count: "5", last: "12:15:41" }
  ]
];

const weightReason = [
  [
    { reason: "丝束的进丝量", count: "22", last: "08:22:31", type: 1 },
    {
      reason: "速比(V1/V0)",
      count: "13",
      last: "11:33:11",
      type: 2
    }
  ],
  [
    { reason: "丝束的进丝量", count: "12", last: "13:05:33", type: 1 },
    {
      reason: "速比(V1/V0)",
      count: "11",
      last: "12:12:41",
      type: 2
    }
  ],
  [
    { reason: "丝束的进丝量", count: "8", last: "10:51:53", type: 1 },
    {
      reason: "速比(V1/V0)",
      count: "9",
      last: "12:15:41",
      type: 2
    }
  ]
];

const weightRecord1 = [
  [
    { reason: "12:12:41", new: "1.56", old: "1.45" },
    { reason: "07:41:31", new: "1.57", old: "1.67" },
    { reason: "09:52:31", new: "1.50", old: "1.56" },
    { reason: "02:11:43", new: "1.30", old: "1.45" },
    { reason: "04:43:45", new: "1.11", old: "1.22" },
    { reason: "13:05:33", new: "1.9", old: "1.87" },
    { reason: "13:12:41", new: "2.1", old: "2.15" }
  ],
  [
    { reason: "12:22:31", new: "2.11", old: "2.3" },
    { reason: "12:42:11", new: "1.83", old: "1.87" },
    { reason: "12:51:53", new: "1.45", old: "1.43" },
    { reason: "12:23:31", new: "1.34", old: "1.36" },
    { reason: "15:42:11", new: "1.55", old: "1.57" },
    { reason: "10:51:53", new: "2.15", old: "3.12" },
    { reason: "12:59:05", new: "1.77", old: "2.12" },
    { reason: "08:11:31", new: "1.86", old: "1.98" }
  ],
  [
    { reason: "09:42:11", new: "1.33", old: "1.78" },
    { reason: "08:51:53", new: "1.11", old: "1.33" },
    { reason: "07:59:05", new: "1.42", old: "1.86" },
    { reason: "13:05:33", new: "1.43", old: "1.52" },
    { reason: "02:55:53", new: "1.45", old: "1.49" },
    { reason: "11:22:41", new: "1.36", old: "1.56" },
    { reason: "09:59:05", new: "1.37", old: "1.38" },
    { reason: "13:05:33", new: "1.68", old: "1.78" },
    { reason: "12:15:41", new: "1.24", old: "1.34" }
  ]
];

const weightRecord2 = [
  [
    { reason: "04:43:45", new: "2350:3500", old: "2200:3300" },
    { reason: "12:22:31", new: "2340:3510", old: "1900:3000" },
    { reason: "12:42:11", new: "2300:3400", old: "1990:2100" },
    { reason: "12:51:53", new: "2310:3100", old: "1980:3000" },
    { reason: "12:12:41", new: "2340:3200", old: "1890:3300" },
    { reason: "13:05:33", new: "2210:3300", old: "2300:3200" },
    { reason: "13:12:41", new: "2200:3000", old: "2460:3170" }
  ],
  [
    { reason: "07:41:31", new: "2200:3300", old: "2300:3400" },
    { reason: "09:52:31", new: "1900:3000", old: "2350:3410" },
    { reason: "02:11:43", new: "1990:2100", old: "2230:3530" },
    { reason: "02:55:53", new: "1980:3000", old: "2430:3100" },
    { reason: "11:22:41", new: "1890:3300", old: "2180:3240" },
    { reason: "09:59:05", new: "2300:3200", old: "2360:3190" },
    { reason: "13:05:33", new: "2460:3170", old: "2480:3260" },
    { reason: "08:11:31", new: "2380:2900", old: "2130:3380" }
  ],
  [
    { reason: "12:23:31", new: "2300:3400", old: "2350:3500" },
    { reason: "15:42:11", new: "2350:3410", old: "2340:3510" },
    { reason: "10:51:53", new: "2230:3530", old: "2300:3400" },
    { reason: "12:59:05", new: "2430:3100", old: "2310:3100" },
    { reason: "09:42:11", new: "2180:3240", old: "2340:3200" },
    { reason: "08:51:53", new: "2360:3190", old: "2210:3300" },
    { reason: "07:59:05", new: "2480:3260", old: "2200:3000" },
    { reason: "13:05:33", new: "2130:3380", old: "2300:3200" },
    { reason: "12:15:41", new: "2090:3060", old: "2460:3170" }
  ]
];

const flat = (x1, x2, prev, next, lineData) => {
  let data1 = [],
    data2 = [];
  data1.push(x1);
  data1.push(prev);
  data2.push(x2);
  data2.push(next);
  lineData.push(data1);
  lineData.push(data2);
};

const flatTo = (x1, x2, value, lineData) => {
  for (let i = x1; i <= x2; i = i + 1) {
    let data = [];
    data.push(i);
    data.push(value);
    lineData.push(data);
  }
};

const fold1 = (x1, x2, x3, x4, y1, y2, y3, lineData) => {
  flatTo(x1, x2, y1, lineData);
  flat(x2, x2 + 1, y1, y2, lineData);
  flatTo(x2 + 1, x3, y2, lineData);
  flat(x3, x3 + 1, y2, y3, lineData);
  flatTo(x3 + 1, x4, y3, lineData);
};

const fold2 = (x1, x2, x3, x4, x5, y1, y2, y3, y4, lineData) => {
  flatTo(x1, x2, y1, lineData);
  flat(x2, x2 + 1, y1, y2, lineData);
  flatTo(x2 + 1, x3, y2, lineData);
  flat(x3, x3 + 1, y2, y3, lineData);
  flatTo(x3 + 1, x4, y3, lineData);
  flat(x4, x4 + 1, y3, y4, lineData);
  flatTo(x4 + 1, x5, y4, lineData);
};

const polyline = (x1, x2, ySet, lineData) => {
  let plus = true;
  let yScope = 3;

  for (let i = x1; i <= x2; i = i + 10) {
    let x = i;

    let y = 0.0;
    let data = [];
    data.push(x);

    let offset = getRandom(0, yScope * 100) / 100;

    if (plus) y = ySet + offset;
    else {
      y = ySet - offset;
    }

    data.push(Math.floor(y * 100) / 100);
    lineData.push(data);
    plus = !plus;
  }
};

const getWeightData1 = () => {
  let xMin = 150;
  let xMax = 11400;

  let yMin = 527;
  let yMax = 575;

  let lineData = [];

  flat(xMin, 152, yMin, 563, lineData);
  flatTo(152, 900, 563, lineData);
  flat(900, 901, 563, 545, lineData);
  flatTo(901, 1000, 545, lineData);
  polyline(1000, 3000, 565, lineData);
  fold1(3000, 3150, 3300, 3550, 565, 550, 530, lineData);
  flat(3550, 3750, 530, 540, lineData);
  flatTo(3750, 3900, 563, lineData);
  fold2(3900, 4300, 4500, 4900, 5200, 563, 559, 553, 545, lineData);
  flat(5200, 5201, 545, 575, lineData);
  polyline(5201, 7500, 575, lineData);

  flat(7500, 7501, 575, 570, lineData);
  fold2(7501, 7700, 7900, 8300, 8500, 570, 565, 560, 550, lineData);
  polyline(8500, 10000, 545, lineData);
  fold2(10001, 10200, 10400, 10500, 10600, 546, 555, 560, 567, lineData);
  polyline(10600, 11000, 570, lineData);
  flat(11000, 11001, 570, 565, lineData);
  flatTo(11001, xMax, 563, lineData);

  return lineData;
};

const getWeightData2 = () => {
  let xMin = 150;
  let xMax = 11400;

  let yMin = 527;
  let yMax = 575;

  let lineData = [];

  flat(xMin, 155, 530, 565, lineData);
  flatTo(155, 500, 565, lineData);
  fold2(500, 600, 800, 900, 1200, 563, 559, 553, 545, lineData);
  flat(1200, 1201, 545, 575, lineData);
  polyline(1201, 2200, 575, lineData);

  flat(2200, 2201, 575, 560, lineData);
  fold2(2201, 2400, 2600, 2900, 3300, 560, 555, 540, 530, lineData);
  polyline(3300, 5000, 529, lineData);

  fold2(5001, 5200, 5400, 5600, 5800, 530, 540, 550, 560, lineData);
  polyline(5801, 8000, 570, lineData);
  flat(8000, 8001, 570, 545, lineData);
  flatTo(8001, 9000, 563, lineData);
  fold1(9000, 9200, 9300, 9500, 565, 550, 540, lineData);

  flat(9500, 9501, 540, 570, lineData);
  polyline(9501, 10500, 573, lineData);
  flatTo(10500, 10501, 563, lineData);
  flatTo(10501, xMax, 545, lineData);

  return lineData;
};

const weightData = [getWeightData1(), getWeightData2()];

export function importData() {
  DataContext.register([
    {
      name: "DEVICE_QUALITY_CYCLE",
      data: [getChartData()]
    },
    {
      name: "QUALITY_CYCLE_PARAMS",
      data: cycleReason
    },
    {
      name: "QUALITY_CYCLE_RECORD",
      data: cycleRecord
    },
    {
      name: "DEVICE_QUALITY_WEIGHT",
      data: weightData
    },
    {
      name: "QUALITY_WEIGHT_PARAMS",
      data: weightReason
    },
    {
      name: "QUALITY_WEIGHT_RECORDFLOAT",
      data: weightRecord1
    },
    {
      name: "QUALITY_WEIGHT_RECORDRATE",
      data: weightRecord2
    }
  ]);
}
